// extracted by mini-css-extract-plugin
export default {"root":"TypeRefSection_root__1AXHJ"};